import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { ButtonMain, FadeLoaderC } from 'components';
import { FrvReport, FmvReport } from './fragments';
import { FindLoad } from 'utils';
import { ordersActions } from 'store';
import { Svg } from 'assets';
import { ReportTypeEnum, Settings } from '../../fragments';

const ACTION_TYPE = 'SINGLE_ORDERS_REQUEST';

export const Reports = () => {
  const [downloadLoad, setDownloadLoad] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const singleOrder = useSelector((state) => state.orders.singleOrder);
  const loading = FindLoad(ACTION_TYPE);

  useEffect(() => {
    dispatch(ordersActions.ordersPost(params?.id));
  }, [dispatch]);

  const handleDownload = async (item) => {
    setDownloadLoad(true);
    try {
      const response = await axios({
        url: `/files/download`,
        method: 'POST',
        responseType: 'blob',
        data: item,
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const fileIndex = response?.data?.type?.search('/');
      const fileType = response?.data?.type?.slice(fileIndex + 1);
      let filename = item?.originalName ? `${singleOrder?.report?.address || singleOrder?.reportFmv?.address}-frv.pdf` : `file.${fileType === 'svg+xml' ? 'svg' : fileType}`;


      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${filename}`);
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } finally {
      setDownloadLoad(false);
    }
  };

  const settingsForDownload = (order) => [
    {
      text: 'Download FRV',
      Svg: Svg.CheckSvg2,
      handleClick: async (toggleMenu) => {
        await handleDownload(order?.frvPdfFile, order);
        toggleMenu();
      },
      loadingItem: downloadLoad,
    },

    {
      text: 'Download FMV',
      Svg: Svg.CheckSvg2,
      handleClick: async (toggleMenu) => {
        await handleDownload(order?.fmvPdfFile, order);
        toggleMenu();
      },
      loadingItem: downloadLoad,
    },
  ];

  if (loading) {
    return (
      <div className='rental-loading-wrapper'>
        <FadeLoaderC big />
        <p className='rental-loading-text'>Generating Your FRV Report...</p>

        <p className='rental-loading-wait'>Please wait a moment while we process your request. Your report will
          be ready
          shortly.
        </p>
      </div>
    );
  }

  return (
    <div className='rental-page'>
      <div className='container'>
        {singleOrder?.id ? (
          <div className='content-button-block'>
            <div className='button-svg_block_mobile'>
              <Svg.CloseSvg className='button-svg_mobile' onClick={() => navigate('/')} />
            </div>

            <div className='rental-wrapper'>
              {singleOrder?.report &&
                <FrvReport singleOrder={singleOrder} />
              }

              {singleOrder?.reportFmv &&
                <FmvReport reportFmv={singleOrder?.reportFmv} />
              }
            </div>

            <div className='button-svg-content'>
              <Svg.CloseSvg className='button-svg' onClick={() => navigate('/')} />

              <Settings
                className='rental-download-button'
                list={singleOrder?.reportType === ReportTypeEnum.ALL && settingsForDownload(singleOrder)}
                onClick={() => handleDownload(singleOrder?.fmvPdfFile || singleOrder?.frvPdfFile, singleOrder)}
                MainSvg={Svg.DownloadSvg}
                itemStyles={{ width: 159 }}
                MainComponent={
                  <ButtonMain
                    text='Download'
                    loading={ singleOrder?.reportType !== ReportTypeEnum.ALL && downloadLoad}
                    startAdornment={<Svg.Download2Svg />}
                  />
                }
              />
            </div>

            <Settings
              className='rental-download-button-mobile'
              list={singleOrder?.reportType === ReportTypeEnum.ALL && settingsForDownload(singleOrder)}
              onClick={() => handleDownload(singleOrder?.fmvPdfFile || singleOrder?.frvPdfFile, singleOrder)}
              MainSvg={Svg.DownloadSvg}
              itemStyles={{ width: 159 }}
              MainComponent={
                <ButtonMain
                  text='Download'
                  loading={ singleOrder?.reportType !== ReportTypeEnum.ALL && downloadLoad}
                  startAdornment={<Svg.Download2Svg />}
                />
              }
            />
          </div>
        ) : (
          <div className='rental-no-data-wrapper'>
            <Svg.NoDataSvg className='rental-no-data-svg' />

            <h4 className='rental-no-data-text'>No Such Report Yet</h4>

            <ButtonMain
              text='Get Your FRV Report Now'
              className='rental-no-data-button'
              startAdornment={<Svg.Listing />}
              onClick={() => navigate('/order-now')}
            />
          </div>
        )}
      </div>
    </div>
  );
};

